import { type ReactNode } from "react";
import type { Locale } from "@/lib/routes";

/**
 * Route wrapper marker for /de/* and /en/* paths.
 *
 * Language is now derived synchronously from the URL inside
 * LanguageProvider (see contexts/LanguageContext.tsx). This wrapper
 * therefore performs no state mutation and adds no render cost — it
 * is kept so the route map in App.tsx stays unchanged and so future
 * locale-scoped concerns (analytics, dir, etc.) have a single hook
 * point.
 */
export function LocaleRoute({ children }: { locale: Locale; children: ReactNode }) {
  return <>{children}</>;
}